import type {ComponentType} from 'react';
import DashboardPage from '../pages/Dashboard/Dashboard';
import LegalPage from '../pages/Legal/LegalPage';
import DocumentsPage from '../pages/Legal/DocumentsPage';
import CompliencePage from '../pages/Complience/CompliencePage';
import PayrollPage from '../pages/Finance/Payroll/PayrollPage';
import EmployeePage from '../pages/Finance/Employee/EmployeePage';
import WorkEvidencePage from '../pages/Finance/Payroll/WorkEvidencePage';
import MonthlyChangesPage from '../pages/Finance/Payroll/MonthlyChangesPage';
import WorkEvidenceApprovalPage from '../pages/Finance/Payroll/WorkEvidenceApprovalPage';
import JobPositionsPage from '../pages/Hr/Jobs/JobPage';
import BranchesPage from '../pages/Hr/Branches/BranchesPage';
import ReportsPage from '../pages/Reports/ReportsPage';
import ContractsPage from '../pages/Contracts/ContractsPage';

export const componentMap: Record<string, ComponentType<any>> = {
    'Home': DashboardPage,
    'dashboard': DashboardPage,
    'Reports': ReportsPage,
    'Contracts': ContractsPage,
    'Legal': LegalPage,
    'Documents': DocumentsPage,
    'Legal/Documents': DocumentsPage,
    'Legal/Contracts': DocumentsPage,
    'Complience': CompliencePage,
    'Employee': EmployeePage,
   // 'Human Resources': DashboardPage,
    'Payroll': PayrollPage,
    'Work Evidence': WorkEvidencePage,
    'Monthly Changes': MonthlyChangesPage,
    'Work Evidence Approvals': WorkEvidenceApprovalPage,
    'Job positions': JobPositionsPage,
    'Branches': BranchesPage
};
